export default __webpack_public_path__ + "static/media/body.0fa83c8c.ogg";